import React, { useState, useEffect } from 'react';
import {
  BreadcrumbManager,
  BreadcrumbManagerState,
  QuerySummary,
  QuerySummaryState
} from '@coveo/headless';
import { headlessEngine } from '../engine';
import { facetBreadcrumb, querySummary } from '../controllers/controller';
import { createDataLayerString } from '../../helpers/helpers';
import { clearAllFacetsContext } from '../../helpers/coveoFacet';

type ClearProps = {
  label: string;
};

function Clear({ label }: ClearProps) {
  const [controller, setController] = useState<BreadcrumbManager | null>(null);
  const [state, setState] = useState<BreadcrumbManagerState | null>(null);

  const [, setSearchController] = useState<QuerySummary | null>(null);
  const [searchState, setSearchState] = useState<QuerySummaryState | null>(
    null
  );

  useEffect(() => {
    if (headlessEngine) {
      setController(facetBreadcrumb as BreadcrumbManager);
      setState((facetBreadcrumb as BreadcrumbManager).state);
      (facetBreadcrumb as BreadcrumbManager).subscribe(() => {
        setState((facetBreadcrumb as BreadcrumbManager).state);
      });

      setSearchController(querySummary as QuerySummary);
      setSearchState((querySummary as QuerySummary).state);
      (querySummary as QuerySummary).subscribe(() => {
        setSearchState((querySummary as QuerySummary).state);
      });
    }
  }, []);

  const handleClearAllFilters = () => {
    clearAllFacetsContext();

    if (controller) controller.deselectAll();
  };

  return (
    <>
      {state?.hasBreadcrumbs || searchState?.hasQuery ? (
        <button
          data-layer={createDataLayerString([
            {
              event: 'clear_all_filters',
              event_category: 'refinement usage',
              event_action: 'clear all filters'
            }
          ])}
          className="btn btn--primary btn--clear-all-filters"
          onClick={handleClearAllFilters}
          type="button"
        >
          {label}
        </button>
      ) : null}
    </>
  );
}

export default Clear;
